import React from 'react';
import { Link } from "react-router-dom"

export default function Sidebar() {
    return (
        <div className="sidebar-container">
            <ul>
                <li>
                    <Link to="/dashboard"><i className="ri-computer-line"></i> Sensors</Link>
                </li>
                <li>
                    <Link to="/devices/history"><i className="ri-history-line"></i> Device history</Link>
                </li>
                <li>
                    <Link to="/lawn"><i className="ri-plant-line"></i> Lawn irrigation</Link>
                </li>
                <li>
                    <Link to="/settings"><i className="ri-settings-3-line"></i> Settings</Link>
                </li>
                <li>
                    <Link to="/about"><i className="ri-information-line"></i> About</Link>
                </li>
                <li>
                    <Link to="/logout"><i className="ri-logout-box-line"></i> Logout</Link>
                </li>
            </ul>
        </div>
    )
}